import camelCase from 'lodash/camelCase';
import PropTypes from 'prop-types';
export const getFacetFromSlug = ({ facets, slug }) => {
  return facets[camelCase(slug)];
};

getFacetFromSlug.propTypes={
  slug:PropTypes.string.isRequired,
  facets:PropTypes.shape({}).isRequired,
};

export default getFacetFromSlug;